import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const privacyPolicySetSettingsFn = (data) =>
  apiClient.post(`${APP_API_URL}privacy-policy/set-settings`, data);

export const usePrivacyPolicySetSettingsMutation = () => {
  return useMutation({
    mutationFn: privacyPolicySetSettingsFn,
  });
};
